<template>
	<div class="term-top">
		<div class="table-label">
			各省{{!type?'植入':'授权'}}家数
		</div>
		<div class="table-content" v-if="datas&&datas.length">
			<div class="content-row" v-for="(item1,index1) in datas" :key="index1">
				<div class="row-item"
					:style="{width:index==2?`${(item1.value/350)*100}%`:item.width,flex:'none',background:index==2?'#DBE7FF':'',padding:index==1||index==2?'0px 0px':'0px 2px'}"
					v-for="(item,index) in titles" :key="'row0'+index">
					<template v-if="!index">
						<img v-if="index1===0||index1===1||index1===2" class="top-image"
							:src="require(`@/assets/icon/top-${index1+1}.png`)" />
						<template v-else>{{index1}}</template>
					</template>
					<template v-else-if="index===2"></template>
					<template v-else>{{item1[item.key]}}</template>
				</div>
			</div>
		</div>
		<div class="table-null" v-else>
			暂无数据
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			datas: {
				type: Array,
				default: []
			},
			type: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				titles: [{
					"label": '排行',
					"key": 'TOPNum',
					"width": "30px"
				}, {
					"label": '省份',
					"key": 'name',
					"width": "50px"
				}, {
					"label": '比例',
					"key": 'name',
					"width": "flex"
				}, {
					"label": '数量',
					"key": 'valueString',
					"width": "60px"
				}]
			}
		}
	}
</script>

<style lang="less">
	.term-top {
		flex: 1;
		height: 504px;
		max-width: 400px;
		padding: 0px 40px;

		.table-label {
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #00266D;
			margin-bottom: 12px;
		}

		.table-label::before {
			content: " ";
			display: inline-block;
			width: 18px;
			height: 18px;
			transform: translateY(4px);
			background: url('../../../../../assets/report/hosp-icon.png') no-repeat;
			background-size: 100% 100%;
		}

		.table-content {
			width: 100%;
			height: 550px;
			// overflow-y: auto;

			.content-row {
				display: flex;
				flex-wrap: nowrap;
				margin-bottom: 5px;

				.row-item {
					padding: 0px 12px;
					// background: #FFFFFF;
					height: 12px;
					line-height: 12px;
					white-space: nowrap;
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 500;
					color: #4E5969;
					display: flex;
					align-items: center;
					overflow-x: auto;
					overflow-y: hidden;
					max-width: 300px;

					//border: 2rpx solid #E5E6EB;
					//box-sizing:;
					.top-image {
						width: 14px;
						height: 14px;
					}
				}

				.row-item::-webkit-scrollbar-thumb {
					border-radius: 10px;
					-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
					background-color: rgb(101, 197, 64);
					cursor: pointer;
				}

				/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
				.row-item::-webkit-scrollbar {
					width: 2px !important;
					/*滚动条宽度*/
					height: 6px !important;
					/*滚动条高度*/
					background-color: white;
					cursor: pointer;
				}


				/*定义滑块 内阴影+圆角*/
				.row-item::-webkit-scrollbar-thumb {
					box-shadow: inset 0 0 0px white;
					-webkit-box-shadow: inset 0 0 0px white;
					background-color: #D9D9D9;
					/*滚动条的背景颜色*/
					border-radius: 8.5px;
					cursor: pointer;
				}
			}
		}

		.table-null {
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 500;
			color: #cccccc;
		}
	}
</style>